
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/customgpt",
      function () {
        return require("private-next-pages/compare/customgpt.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/customgpt"])
      });
    }
  